import React from 'react';
import {withRouter} from 'react-router-dom';
import { Link } from 'react-router-dom';

import './section.card.book.styles.css';

const Card = ({book}) => (
    <Link className='logo-container' to={'/viewbook/'+book.id}>
        <div className='card-container-responsive'>
            <div className='card-container' >
                <h2 className='book-title'> { book.name } </h2>
            </div>
        </div>
    </Link>
);
export default withRouter(Card) ;
